import React from 'react';
import { Package } from 'lucide-react';

const ProductTabContent = () => {
  return (
    <div className="text-center py-12">
      <Package size={48} className="mx-auto text-gray-300 mb-4" />
      <h3 className="text-xl font-semibold text-gray-700 mb-2">Produtos</h3>
      <p className="text-gray-500">Em breve você poderá visualizar e comprar produtos</p>
    </div>
  );
};

export default ProductTabContent;